import { render, staticRenderFns } from "./TableSettingsModal.vue?vue&type=template&id=6f42669a"
import script from "./TableSettingsModal.vue?vue&type=script&lang=js"
export * from "./TableSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TableSettingsModal.vue?vue&type=style&index=0&id=6f42669a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports